/**
 * Zoho contact forms (front-page CTA, website contact-new / contact-v2).
 * zoho-validation.js (enqueued by those components) provides zf_ValidateAndSubmit()
 * and reads the zf_* globals below, so they stay on window.
 */
var ZOHO_FORMS = {
    form_cta: {
        errorSuffix: '_cta_error',
        submitSelector: '.cta-btn-send',
        sendingHtml: 'Sending...',
        fields: ['SingleLine2', 'SingleLine1', 'Email', 'PhoneNumber_countrycode', 'SingleLine', 'Website', 'DecisionBox']
    },
    contact_new_form: {
        errorSuffix: '_error',
        submitSelector: '.btn-send',
        sendingHtml: null, // set per form below (contact-v2 shows the dot)
        fields: ['SingleLine2', 'SingleLine1', 'Email', 'PhoneNumber_countrycode', 'SingleLine', 'Website', 'Dropdown', 'Checkbox', 'Dropdown1', 'MultiLine', 'DecisionBox']
    }
};

document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.zf_ValidateAndSubmit !== 'function') return;

    var regex = window.zf_SetDateAndMonthRegexBasedOnDateFormate('dd-MMM-yyyy');
    window.zf_DateRegex = new RegExp(regex[0]);
    window.zf_MonthYearRegex = new RegExp(regex[1]);
    window.zf_MandArray = ['SingleLine2', 'SingleLine1', 'Email', 'PhoneNumber_countrycode', 'SingleLine'];
    window.isSalesIQIntegrationEnabled = false;
    window.salesIQFieldsArray = [];

    // Show the error element that belongs to the form being validated
    window.zf_ShowErrorMsg = function (name) {
        var config = window.zf_ActiveForm && ZOHO_FORMS[window.zf_ActiveForm.id];
        var errEl = document.getElementById(name + (config ? config.errorSuffix : '_error'));
        if (errEl) errEl.style.display = 'block';
    };

    Object.keys(ZOHO_FORMS).forEach(function (formId) {
        var form = document.getElementById(formId);
        if (!form) return;
        var config = ZOHO_FORMS[formId];

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            document.charset = 'UTF-8';
            window.zf_ActiveForm = form;
            window.zf_FieldArray = config.fields;

            if (!window.zf_ValidateAndSubmit()) return;

            var submitBtn = form.querySelector(config.submitSelector);
            if (submitBtn) {
                submitBtn.innerHTML = config.sendingHtml || (submitBtn.querySelector('.dot') ? '<span class="dot"></span> Sending...' : 'Sending...');
                submitBtn.disabled = true;
            }
            // Submit directly to Zoho
            form.submit();
        });
    });
});
